import {useMemo} from 'react';
import {BoundSearchQuery} from "../../types/common/BoundSearchQuery";
import {useGetRequestAutoAbortPaginated} from "../request/useGetRequestAutoAbortPaginated";
import useDebounce from "../useDebounce";

interface UseGetBoundReportPaginatedProps {
  requestUrl: string;
  requestParams?: BoundSearchQuery;
}

/**
 * Hook for reactively grabbing data from the supplied endpoint.
 * Automatically aborts previous requests and separates pagination info and the data
 **/
const useGetBoundReportPaginated = <T>({ requestUrl, requestParams }: UseGetBoundReportPaginatedProps) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const queryParams = useMemo(() => (requestParams), [JSON.stringify(requestParams)]);

  const debouncedQueryParams = useDebounce(queryParams, 250);

  const {
    responseContent: reportPayload,
    pageInfo,
    isLoading,
    error,
    doRequest,
  } = useGetRequestAutoAbortPaginated<T>({ requestUrl, queryParams: debouncedQueryParams})

  return {
    reportPayload,
    pageInfo,
    isLoading,
    error,
    doRequest,
  }
}

export { useGetBoundReportPaginated };
